// Generated by Melange

import * as Caml_obj from "melange.js/caml_obj.js";
import * as Curry from "melange.js/curry.js";
import * as Mapre_chat__Chat_tool from "../../shared/chat/chat_tool.js";
import * as Stdlib from "melange/stdlib.js";
import * as Stdlib__Hashtbl from "melange/hashtbl.js";
import * as Stdlib__Int from "melange/int.js";
import * as Stdlib__List from "melange/list.js";
import * as Stdlib__Option from "melange/option.js";
import * as Stdlib__Set from "melange/set.js";

const Ints = Stdlib__Set.Make({
  compare: Stdlib__Int.compare
});

function merge_events(events) {
  const calls = Stdlib__Hashtbl.create(undefined, 32);
  const order = {
    contents: /* [] */ 0
  };
  Stdlib__List.iter((function ($$event) {
    if (!($$event.kind !== "agent_control" && !($$event.kind === "command_result" && $$event.text === ""))) {
      return;
    }
    const tool = $$event.tool;
    if (tool === undefined) {
      order.contents = {
        hd: {
          NAME: "Event",
          VAL: $$event
        },
        tl: order.contents
      };
      return;
    }
    const key_0 = $$event.run_id;
    const key_1 = $$event.source_epoch;
    const key_2 = tool.id;
    const key = [
      key_0,
      key_1,
      key_2
    ];
    const previous = Stdlib__Hashtbl.find_opt(calls, key);
    if (previous !== undefined) {
      const merged = Stdlib__Option.map((function (old) {
        return Mapre_chat__Chat_tool.merge(old, tool);
      }), previous.tool);
      return Stdlib__Hashtbl.replace(calls, key, {
        attachments: previous.attachments,
        seq: previous.seq,
        revision: previous.revision,
        run_id: previous.run_id,
        source_epoch: previous.source_epoch,
        kind: previous.kind,
        text: previous.text,
        truncated: previous.truncated,
        permission_update: previous.permission_update,
        tool: merged,
        command_id: previous.command_id,
        actor: previous.actor
      });
    }
    Stdlib__Hashtbl.add(calls, key, $$event);
    order.contents = {
      hd: {
        NAME: "Tool",
        VAL: key
      },
      tl: order.contents
    };
  }), events);
  return Stdlib__List.rev_map((function (param) {
    if (param.NAME === "Tool") {
      return Stdlib__Hashtbl.find(calls, param.VAL);
    } else {
      return param.VAL;
    }
  }), order.contents);
}

function kind_of($$event) {
  if ($$event.truncated) {
    return "Notice";
  }
  const match = $$event.kind;
  switch (match) {
    case "agent_thought" :
      return "Thought";
    case "assistant_message" :
      return "Assistant";
    case "command_result" :
    case "source_gap" :
      return "Notice";
    case "user_message" :
      return "User";
    default:
      if ($$event.tool !== undefined) {
        return "Work";
      } else if ($$event.text !== "") {
        return "Assistant";
      } else {
        return "Skip";
      }
  }
}

function grouped(events, commands) {
  const build = function (_acc, _work, _param) {
    while (true) {
      const param = _param;
      const work = _work;
      const acc = _acc;
      if (!param) {
        if (Caml_obj.caml_equal(work, /* [] */ 0)) {
          return acc;
        } else {
          return {
            hd: {
              NAME: "Group",
              VAL: Stdlib__List.rev(work)
            },
            tl: acc
          };
        }
      }
      const rest = param.tl;
      const $$event = param.hd;
      const match = kind_of($$event);
      if (match === "Assistant") {
        const acc$1 = Caml_obj.caml_equal(work, /* [] */ 0) ? acc : ({
            hd: {
              NAME: "Group",
              VAL: Stdlib__List.rev(work)
            },
            tl: acc
          });
        _param = rest;
        _work = /* [] */ 0;
        _acc = {
          hd: {
            NAME: "One",
            VAL: {
              TAG: /* Assistant */ 1,
              _0: $$event
            }
          },
          tl: acc$1
        };
        continue;
      }
      if (match === "Thought") {
        const acc$2 = Caml_obj.caml_equal(work, /* [] */ 0) ? acc : ({
            hd: {
              NAME: "Group",
              VAL: Stdlib__List.rev(work)
            },
            tl: acc
          });
        _param = rest;
        _work = /* [] */ 0;
        _acc = {
          hd: {
            NAME: "One",
            VAL: {
              TAG: /* Thought */ 2,
              _0: $$event
            }
          },
          tl: acc$2
        };
        continue;
      }
      if (match === "Skip") {
        _param = rest;
        continue;
      }
      if (match === "User") {
        const acc$3 = Caml_obj.caml_equal(work, /* [] */ 0) ? acc : ({
            hd: {
              NAME: "Group",
              VAL: Stdlib__List.rev(work)
            },
            tl: acc
          });
        _param = rest;
        _work = /* [] */ 0;
        _acc = {
          hd: {
            NAME: "One",
            VAL: {
              TAG: /* User */ 0,
              _0: $$event
            }
          },
          tl: acc$3
        };
        continue;
      }
      if (match === "Work") {
        _param = rest;
        _work = {
          hd: $$event,
          tl: work
        };
        continue;
      }
      const acc$4 = Caml_obj.caml_equal(work, /* [] */ 0) ? acc : ({
          hd: {
            NAME: "Group",
            VAL: Stdlib__List.rev(work)
          },
          tl: acc
        });
      _param = rest;
      _work = /* [] */ 0;
      _acc = {
        hd: {
          NAME: "One",
          VAL: {
            TAG: /* Notice */ 4,
            _0: $$event
          }
        },
        tl: acc$4
      };
      continue;
    };
  };
  const command_rows = Stdlib__List.map((function (c) {
    return {
      key: "c" + c.id,
      item: {
        TAG: /* Command */ 5,
        _0: c
      }
    };
  }), Stdlib__List.filter((function (c) {
    if (c.text !== "" || Caml_obj.caml_notequal(c.attachments, /* [] */ 0)) {
      return !c.in_timeline;
    } else {
      return false;
    }
  }), commands));
  const items = Stdlib__List.rev_map((function (param) {
    if (param.NAME === "Group") {
      const calls = param.VAL;
      return {
        key: "w" + String(Stdlib__List.hd(calls).seq),
        item: {
          TAG: /* Work */ 3,
          _0: calls
        }
      };
    }
    const item = param.VAL;
    let seq;
    if (/* tag */ typeof item !== "object" && typeof item !== "function") {
      seq = 0;
    } else {
      switch (item.TAG) {
        case /* Work */ 3 :
        case /* Command */ 5 :
          seq = 0;
          break;
        default:
          seq = item._0.seq;
      }
    }
    return {
      key: "e" + String(seq),
      item
    };
  }), build(/* [] */ 0, /* [] */ 0, merge_events(events)));
  return Stdlib.$at(command_rows, items);
}

function live(events) {
  let _count = Stdlib__List.length(events) - 1000 | 0;
  let _xs = events;
  while (true) {
    const xs = _xs;
    const count = _count;
    if (count <= 0) {
      return xs;
    }
    if (!xs) {
      return /* [] */ 0;
    }
    _xs = xs.tl;
    _count = count - 1 | 0;
    continue;
  };
}

function work_active(calls) {
  return Stdlib__List.exists((function (e) {
    const t = e.tool;
    if (t === undefined) {
      return false;
    }
    const match = t.status;
    if (match === undefined) {
      return false;
    }
    switch (match) {
      case /* Completed */ 2 :
      case /* Failed */ 3 :
        return false;
      default:
        return true;
    }
  }), calls);
}

function group_expanded(events, expanded, collapsed, key) {
  const match = Stdlib__List.find_opt((function (r) {
    return r.key === "w" + String(key);
  }), grouped(events, /* [] */ 0));
  if (match === undefined) {
    return false;
  }
  const calls = match.item;
  if (/* tag */ typeof calls !== "object" && typeof calls !== "function") {
    return false;
  }
  if (calls.TAG !== /* Work */ 3) {
    return false;
  }
  const calls$1 = calls._0;
  if (work_active(calls$1) || Curry._2(Ints.mem, key, expanded) || Stdlib__List.length(calls$1) <= 5) {
    return !Curry._2(Ints.mem, key, collapsed);
  } else {
    return false;
  }
}

export {
  Ints,
  merge_events,
  grouped,
  live,
  work_active,
  group_expanded,
}
/* Ints Not a pure module */
